import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AUTH_REPOSITORY } from '../domain/repositories/auth.repository';
import { AuthRemoteDatasource } from './datasources/remote/auth.remote-datasource';
import { AuthMapper } from './mappers/auth.mapper';
import { AuthRepositoryImpl } from './repositories/auth.repository.impl';
import { AuthRefreshService } from './services/auth-refresh.service';
import { AccountPresenceHeartbeatService } from './services/account-presence-heartbeat.service';
import { TokenRefreshSchedulerService } from './services/token-refresh-scheduler.service';

export function provideAuthData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AuthRemoteDatasource,
    AuthMapper,
    AuthRefreshService,
    AccountPresenceHeartbeatService,
    TokenRefreshSchedulerService,
    { provide: AUTH_REPOSITORY, useClass: AuthRepositoryImpl },
  ]);
}
